export const isDev = () => {
    return process.env.NODE_ENV === 'development';
}

export const isDebug = () => {
    return process.env.REACT_APP_DEBUG_MODE === 'true';
}
